(function () {
    'use strict';

    angular.module("imApp").factory("helpDocSearchService", ['$ihttp', function ($ihttp) {
        let service = {
            getHelpDocSearch: function (parms) {
                return $ihttp.post({
                    method: 2619,
                    parameters: parms || {}
                });
            },
            listHelpDocSearch: function (parms) {
                return $ihttp.post({
                    method: 2620,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();